const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domHeader: $('.site-header'),
	classHeaderScroll: 'is-sticky',
	classTopBarHidden: 'is-topbar-hidden',
	lastScrollTop: 0,

	/** @description Initialize */
	init: function() {
		this.headerSticky();
		$(document).on('scroll', this.headerSticky.bind(this));
		$(window).on('load', this.headerSticky.bind(this));
	},

	headerSticky: function() {
		const scrollTop = $(document).scrollTop();
		this.$domHeader.toggleClass(this.classHeaderScroll, scrollTop > 20);
		this.$domHeader.toggleClass(this.classTopBarHidden, scrollTop > this.lastScrollTop && scrollTop > 20);
		this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
	},
};

export default Header;
